import React from 'react';

function isChunkLoadError(error) {
  if (!error) return false;
  const msg = error.message || '';
  return (
    error.name === 'ChunkLoadError' ||
    /loading chunk \d+ failed/i.test(msg) ||
    /loading css chunk \d+ failed/i.test(msg) ||
    /failed to fetch dynamically imported module/i.test(msg)
  );
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isChunkError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, isChunkError: isChunkLoadError(error) };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      const { isChunkError } = this.state;
      return (
        <div className="min-h-screen flex items-center justify-center bg-[var(--bg-secondary)]">
          <div className="text-center p-8 max-w-md">
            <img
              src="/Logo-digi-bakery-512.png"
              alt="Logo"
              className="w-16 h-16 mb-6 mx-auto opacity-60"
            />
            <p className="text-lg text-[var(--text-primary)] font-semibold mb-2">
              {isChunkError
                ? 'A new version is available.'
                : 'Something went wrong.'}
            </p>
            <p className="text-sm text-[var(--text-secondary)] mb-6">
              {isChunkError
                ? 'Please refresh to load the latest version.'
                : 'An unexpected error occurred. Refreshing usually fixes it.'}
            </p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2.5 bg-[var(--btn-primary-bg)] hover:bg-[var(--btn-primary-hover-bg)] text-[var(--btn-primary-text)] font-semibold rounded-lg transition-colors"
            >
              {isChunkError ? 'Refresh to update' : 'Refresh page'}
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
